"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _goods = require("@/api/goods/goods");
var _dishGroup = require("@/api/goods/dishGroup");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DishGroupBatch',
  data: function data() {
    return {
      // 商品列表数据
      tableData: [],
      allProducts: [],
      filteredProductList: [],
      productSearch: '',
      // 已选择的商品
      selectedTableProducts: [],
      // 添加商品弹框
      addDialogVisible: false,
      addProductSearch: '',
      addFilteredProductList: [],
      selectedAddProducts: [],
      addLoading: false,
      // 批量操作表单
      form: {
        operation: '',
        groupIds: []
      },
      // 分组选项
      groupOptions: [],
      // 商品所属分组信息缓存
      goodsGroupsCache: {},
      // 提交状态
      submitting: false
    };
  },
  computed: {
    headerCellStyle: function headerCellStyle() {
      return {
        background: '#F5F5F7',
        color: '#1D1D1F',
        fontWeight: 600,
        fontSize: '13px',
        borderBottom: '1px solid #E5E5E7'
      };
    },
    // 是否可以提交
    canSubmit: function canSubmit() {
      if (this.tableData.length === 0) return false;
      if (this.form.operation === 'add') {
        return this.form.groupIds && this.form.groupIds.length > 0;
      } else if (this.form.operation === 'clear') {
        // 检查是否有任何商品选中了分组
        return this.tableData.some(function (item) {
          return item.selectedGroups && item.selectedGroups.length > 0;
        });
      }
      return false;
    }
  },
  mounted: function mounted() {
    this.getAllProducts();
    this.getGroupOptions();
  },
  methods: {
    // 获取所有商品
    getAllProducts: function () {
      var _getAllProducts = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.addLoading = true;
              _context.prev = 1;
              params = {
                page: 1,
                limit: 1000
              };
              _context.next = 2;
              return (0, _goods.queryList)(params);
            case 2:
              res = _context.sent;
              if (res.code === 200) {
                this.allProducts = res.records || [];
                this.tableData = [];
                this.filteredProductList = [];
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              this.$message.error('获取商品列表失败');
            case 4:
              _context.prev = 4;
              this.addLoading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getAllProducts() {
        return _getAllProducts.apply(this, arguments);
      }
      return getAllProducts;
    }(),
    // 获取分组选项
    getGroupOptions: function () {
      var _getGroupOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _dishGroup.queryList)({
                limit: 1000,
                page: 1
              });
            case 1:
              res = _context2.sent;
              if (res.code === 200) {
                this.groupOptions = res.records || [];
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取分组列表失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getGroupOptions() {
        return _getGroupOptions.apply(this, arguments);
      }
      return getGroupOptions;
    }(),
    // 搜索商品
    handleProductSearch: function () {
      var _handleProductSearch = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var keyword;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.productSearch) {
                _context3.next = 1;
                break;
              }
              this.filteredProductList = (0, _toConsumableArray2.default)(this.tableData);
              return _context3.abrupt("return");
            case 1:
              keyword = this.productSearch.toLowerCase();
              this.filteredProductList = this.tableData.filter(function (item) {
                var nameMatch = item.goodsName && item.goodsName.toLowerCase().includes(keyword);
                var codeMatch = item.goodsCode && item.goodsCode.toLowerCase().includes(keyword);
                return nameMatch || codeMatch;
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleProductSearch() {
        return _handleProductSearch.apply(this, arguments);
      }
      return handleProductSearch;
    }(),
    // 添加商品弹框 - 搜索商品
    handleAddProductSearch: function () {
      var _handleAddProductSearch = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var keyword;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.addProductSearch) {
                _context4.next = 1;
                break;
              }
              this.addFilteredProductList = (0, _toConsumableArray2.default)(this.allProducts);
              return _context4.abrupt("return");
            case 1:
              keyword = this.addProductSearch.toLowerCase();
              this.addFilteredProductList = this.allProducts.filter(function (item) {
                var nameMatch = item.goodsName && item.goodsName.toLowerCase().includes(keyword);
                var codeMatch = item.goodsCode && item.goodsCode.toLowerCase().includes(keyword);
                return nameMatch || codeMatch;
              });
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleAddProductSearch() {
        return _handleAddProductSearch.apply(this, arguments);
      }
      return handleAddProductSearch;
    }(),
    // 打开添加商品弹框
    handleOpenAddDialog: function handleOpenAddDialog() {
      var _this = this;
      this.addDialogVisible = true;
      this.addProductSearch = '';
      this.addFilteredProductList = (0, _toConsumableArray2.default)(this.allProducts);
      this.selectedAddProducts = [];
      this.$nextTick(function () {
        _this.setExistingSelection();
      });
    },
    // 关闭添加商品弹框
    handleCloseAddDialog: function handleCloseAddDialog() {
      this.addDialogVisible = false;
      this.addProductSearch = '';
      this.selectedAddProducts = [];
    },
    // 设置已选择的商品
    setExistingSelection: function setExistingSelection() {
      var _this2 = this;
      if (!this.$refs.addProductTableRef) return;
      this.$refs.addProductTableRef.clearSelection();
      var existingIds = new Set(this.tableData.map(function (item) {
        return item.goodsId;
      }));
      this.addFilteredProductList.forEach(function (row) {
        if (existingIds.has(row.id)) {
          _this2.$refs.addProductTableRef.toggleRowSelection(row, true);
        }
      });
    },
    // 添加商品选择变化
    handleAddSelectionChange: function handleAddSelectionChange(selection) {
      this.selectedAddProducts = selection;
    },
    // 确认添加商品
    handleConfirmAdd: function handleConfirmAdd() {
      if (this.selectedAddProducts.length === 0) {
        this.$message.warning('请至少选择一件商品');
        return;
      }

      // 过滤掉已存在的商品
      var existingIds = new Set(this.tableData.map(function (item) {
        return item.goodsId;
      }));
      var newProducts = this.selectedAddProducts.filter(function (product) {
        return !existingIds.has(product.id);
      });
      if (newProducts.length > 0) {
        var _this$tableData;
        // 批量查询商品的分组信息
        this.loadGoodsGroupsInfo(newProducts);
        (_this$tableData = this.tableData).push.apply(_this$tableData, (0, _toConsumableArray2.default)(newProducts.map(function (p) {
          return {
            goodsId: p.id,
            goodsName: p.goodsName,
            goodsCode: p.goodsCode,
            goodsThumbnailUrl: p.goodsThumbnailUrl,
            groups: [],
            selectedGroups: [] // 初始化选中的分组数组
          };
        })));
        // 更新过滤后的商品列表
        this.filteredProductList = (0, _toConsumableArray2.default)(this.tableData);
        this.$message.success("\u6210\u529F\u6DFB\u52A0 ".concat(newProducts.length, " \u4EF6\u5546\u54C1"));
      } else {
        this.$message.warning('所选商品已在列表中');
      }
      this.addDialogVisible = false;
    },
    // 批量加载商品分组信息
    loadGoodsGroupsInfo: function () {
      var _loadGoodsGroupsInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(products) {
        var _this3 = this;
        var goodsIds, res, groupsMap, _t3;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              goodsIds = products.map(function (p) {
                return p.id;
              });
              if (!(goodsIds.length === 0)) {
                _context5.next = 1;
                break;
              }
              return _context5.abrupt("return");
            case 1:
              _context5.prev = 1;
              _context5.next = 2;
              return (0, _dishGroup.queryGoodsGroups)({
                goodsIds: goodsIds
              });
            case 2:
              res = _context5.sent;
              console.log('查询商品分组结果:', res);
              if (res.code === 0 || res.code === 200) {
                groupsMap = {};
                if (res.data && Array.isArray(res.data)) {
                  res.data.forEach(function (item) {
                    groupsMap[item.goodsId] = item.groups || [];
                  });
                }
                console.log('分组映射:', groupsMap);

                // 更新商品的分组信息
                this.tableData.forEach(function (tableItem) {
                  if (groupsMap[tableItem.goodsId]) {
                    _this3.$set(tableItem, 'groups', groupsMap[tableItem.goodsId]);
                    console.log("\u5546\u54C1 ".concat(tableItem.goodsId, " \u7684\u5206\u7EC4:"), tableItem.groups);
                  }
                });
              }
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t3 = _context5["catch"](1);
              console.error('获取商品分组信息失败:', _t3);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function loadGoodsGroupsInfo(_x) {
        return _loadGoodsGroupsInfo.apply(this, arguments);
      }
      return loadGoodsGroupsInfo;
    }(),
    // 商品列表选择变化
    handleTableSelectionChange: function handleTableSelectionChange(selection) {
      this.selectedTableProducts = selection;
    },
    // 移除商品
    handleRemove: function handleRemove(row) {
      var _this4 = this;
      this.$confirm("\u786E\u5B9A\u8981\u79FB\u9664\u5546\u54C1 \"".concat(row.goodsName, "\" \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var index = _this4.tableData.findIndex(function (item) {
          return item.goodsId === row.goodsId;
        });
        if (index > -1) {
          _this4.tableData.splice(index, 1);
          _this4.filteredProductList = (0, _toConsumableArray2.default)(_this4.tableData);
        }
        _this4.$message.success('移除成功');
      }).catch(function () {});
    },
    // 批量删除商品
    handleBatchRemove: function handleBatchRemove() {
      var _this5 = this;
      if (this.selectedTableProducts.length === 0) {
        this.$message.warning('请至少选择一件商品');
        return;
      }
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u9009\u4E2D\u7684 ".concat(this.selectedTableProducts.length, " \u4EF6\u5546\u54C1\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var selectedIds = _this5.selectedTableProducts.map(function (item) {
          return item.goodsId;
        });
        _this5.tableData = _this5.tableData.filter(function (item) {
          return !selectedIds.includes(item.goodsId);
        });
        _this5.filteredProductList = (0, _toConsumableArray2.default)(_this5.tableData);
        _this5.selectedTableProducts = [];
        _this5.$message.success('批量删除成功');
      }).catch(function () {});
    },
    // 取消
    handleCancel: function handleCancel() {
      var _this6 = this;
      this.form.operation = '';
      this.form.groupIds = [];
      // 清除每个商品的选中分组
      this.tableData.forEach(function (item) {
        _this6.$set(item, 'selectedGroups', []);
      });
    },
    // 强制更新视图
    handleSelectionChange: function handleSelectionChange() {
      // 触发视图更新
      this.$forceUpdate();
    },
    // 提交批量操作
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(this.tableData.length === 0)) {
                _context6.next = 1;
                break;
              }
              this.$message.warning('请先添加商品');
              return _context6.abrupt("return");
            case 1:
              if (!(this.form.operation === 'add')) {
                _context6.next = 3;
                break;
              }
              _context6.next = 2;
              return this.handleBatchAdd();
            case 2:
              _context6.next = 4;
              break;
            case 3:
              if (!(this.form.operation === 'clear')) {
                _context6.next = 4;
                break;
              }
              _context6.next = 4;
              return this.handleBatchClear();
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    // 批量添加分组
    handleBatchAdd: function () {
      var _handleBatchAdd = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var goodsIds, params, res, _t4;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(!this.form.groupIds || this.form.groupIds.length === 0)) {
                _context7.next = 1;
                break;
              }
              this.$message.warning('请选择要添加的分组');
              return _context7.abrupt("return");
            case 1:
              this.submitting = true;
              _context7.prev = 2;
              goodsIds = this.tableData.map(function (item) {
                return item.goodsId;
              });
              params = {
                goodsIds: goodsIds,
                groupIds: this.form.groupIds
              };
              _context7.next = 3;
              return (0, _dishGroup.batchAddGroups)(params);
            case 3:
              res = _context7.sent;
              if (!(res.code === 0 || res.code === 200)) {
                _context7.next = 4;
                break;
              }
              this.$message.success(res.msg || '批量添加分组成功');
              // 重新加载商品分组信息
              _context7.next = 4;
              return this.reloadAllGoodsGroups();
            case 4:
              _context7.next = 6;
              break;
            case 5:
              _context7.prev = 5;
              _t4 = _context7["catch"](2);
              this.$message.error('批量添加分组失败');
            case 6:
              _context7.prev = 6;
              this.submitting = false;
              return _context7.finish(6);
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[2, 5, 6, 7]]);
      }));
      function handleBatchAdd() {
        return _handleBatchAdd.apply(this, arguments);
      }
      return handleBatchAdd;
    }(),
    // 批量清除分组
    handleBatchClear: function () {
      var _handleBatchClear = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _this7 = this;
        var clearOperations, _iterator, _step, item, totalCount;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              // 收集所有商品选中的分组
              clearOperations = [];
              _iterator = _createForOfIteratorHelper(this.tableData);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  if (item.selectedGroups && item.selectedGroups.length > 0) {
                    clearOperations.push({
                      goodsId: item.goodsId,
                      goodsName: item.goodsName,
                      groupIds: item.selectedGroups
                    });
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              if (!(clearOperations.length === 0)) {
                _context9.next = 1;
                break;
              }
              this.$message.warning('请至少选择一个要清除的分组');
              return _context9.abrupt("return");
            case 1:
              // 构建确认消息
              totalCount = clearOperations.reduce(function (sum, op) {
                return sum + op.groupIds.length;
              }, 0);
              this.$confirm("\u786E\u8BA4\u6E05\u9664 ".concat(totalCount, " \u4E2A\u5206\u7EC4\u5173\u8054\u5417\uFF1F\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\uFF01"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var successCount, _i, _clearOperations, operation, params, res, _t5;
                return regeneratorRuntime.wrap(function (_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      _this7.submitting = true;
                      _context8.prev = 1;
                      // 逐个商品清除分组
                      successCount = 0;
                      _i = 0, _clearOperations = clearOperations;
                    case 2:
                      if (!(_i < _clearOperations.length)) {
                        _context8.next = 5;
                        break;
                      }
                      operation = _clearOperations[_i];
                      params = {
                        goodsIds: [operation.goodsId],
                        groupIds: operation.groupIds
                      };
                      _context8.next = 3;
                      return (0, _dishGroup.batchClearGroups)(params);
                    case 3:
                      res = _context8.sent;
                      if (res.code === 0 || res.code === 200) {
                        successCount++;
                      }
                    case 4:
                      _i++;
                      _context8.next = 2;
                      break;
                    case 5:
                      _this7.$message.success("\u6279\u91CF\u6E05\u9664\u5206\u7EC4\u6210\u529F\uFF0C\u5171\u5904\u7406 ".concat(successCount, " \u4E2A\u5546\u54C1"));
                      // 重新加载商品分组信息
                      _context8.next = 6;
                      return _this7.reloadAllGoodsGroups();
                    case 6:
                      _context8.next = 8;
                      break;
                    case 7:
                      _context8.prev = 7;
                      _t5 = _context8["catch"](1);
                      _this7.$message.error('批量清除分组失败');
                    case 8:
                      _context8.prev = 8;
                      _this7.submitting = false;
                      return _context8.finish(8);
                    case 9:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8, null, [[1, 7, 8, 9]]);
              }))).catch(function () {});
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function handleBatchClear() {
        return _handleBatchClear.apply(this, arguments);
      }
      return handleBatchClear;
    }(),
    // 重新加载所有商品的分组信息
    reloadAllGoodsGroups: function () {
      var _reloadAllGoodsGroups = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var _this8 = this;
        var allGoodsIds, res, groupsMap, _t6;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              allGoodsIds = this.tableData.map(function (item) {
                return item.goodsId;
              });
              _context0.prev = 1;
              _context0.next = 2;
              return (0, _dishGroup.queryGoodsGroups)({
                goodsIds: allGoodsIds
              });
            case 2:
              res = _context0.sent;
              if (res.code === 0 || res.code === 200) {
                groupsMap = {};
                if (res.data && Array.isArray(res.data)) {
                  res.data.forEach(function (item) {
                    groupsMap[item.goodsId] = item.groups || [];
                  });
                }
                this.tableData.forEach(function (item) {
                  item.groups = groupsMap[item.goodsId] || [];
                  // 清除该商品的选中分组
                  _this8.$set(item, 'selectedGroups', []);
                });

                // 重置表单
                this.form.operation = '';
                this.form.groupIds = [];
              }
              _context0.next = 4;
              break;
            case 3:
              _context0.prev = 3;
              _t6 = _context0["catch"](1);
              console.error('重新加载分组信息失败:', _t6);
            case 4:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[1, 3]]);
      }));
      function reloadAllGoodsGroups() {
        return _reloadAllGoodsGroups.apply(this, arguments);
      }
      return reloadAllGoodsGroups;
    }(),
    // 获取商品名称
    getGoodsName: function getGoodsName(goodsId) {
      var item = this.tableData.find(function (i) {
        return i.goodsId === goodsId;
      });
      return item ? item.goodsName : "#".concat(goodsId);
    }
  }
};